import MenuTabs from "./MenuTabs.component.jsx";

export default MenuTabs;